const highlights = [
  {
    icon: "ri-stack-line",
    title: "海量影视资料",
    desc: "涵盖《顽皮的女朋友》及各类影视作品的完整资料与剧情介绍。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维分类检索",
    desc: "按类型、地区、年份多维筛选，快速定位想看的影视内容。",
  },
  {
    icon: "ri-newspaper-line",
    title: "实时资讯速递",
    desc: "汇集剧集动态、行业观察与深度访谈，紧跟影视圈热点。",
  },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-label tracking-wide">
              <i className="ri-clapperboard-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
              顽皮的女朋友影视内容站
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              本站以《顽皮的女朋友》为核心，围绕影视内容展示与剧情资讯分享，打造优质的影视内容聚合平台。
              我们致力于为影视剧爱好者提供清晰、完整且易于浏览的作品资料，帮助你在一处了解作品详情、分类列表与最新动态。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              站内所有内容均为演示资料，用于展示平台的信息组织方式与浏览体验，不涉及真实评分、播放或下载数据。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 gap-3 md:gap-4">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70"
              >
                <span className="w-11 h-11 md:w-12 md:h-12 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}